import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Colombianos que quieren bajar de peso rápido y sin efecto rebote.', 'Personas que no tienen tiempo para cocinar platos complicados.', 'Trabajadores que almuerzan fuera de casa y necesitan opciones reales.', 'Familias que cuidan su presupuesto pero quieren mejorar su salud.'];
  const notForWho = ['Personas que buscan una "pastilla mágica" sin cambiar lo que comen.', 'Quienes prefieren seguir dietas restrictivas basadas en pura lechuga.', 'Gente que no está dispuesta a dejar el azúcar y la panela por 7 días.'];
  return <section className="bg-[#0D0D0D] text-white py-16 md:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="font-montserrat font-black text-3xl md:text-4xl text-center mb-16 uppercase" data-id="element-3">
          ¿Para quién es este sistema?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-4">
          {/* For Who */}
          <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-10" data-id="element-5">
            <h3 className="font-montserrat font-bold text-2xl mb-8 text-[#22C55E] flex items-center gap-3" data-id="element-6">
              <CheckCircle2Icon className="w-8 h-8" data-id="element-7" />
              ESTO SÍ ES PARA TI SI:
            </h3>
            <ul className="space-y-6" data-id="element-8">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-9">
                  <div className="mt-1 bg-[#22C55E]/20 p-1 rounded-full" data-id="element-10">
                    <CheckCircle2Icon className="w-5 h-5 text-[#22C55E]" data-id="element-11" />
                  </div>
                  <span className="font-inter text-lg text-gray-300" data-id="element-12">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Not For Who */}
          <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-10" data-id="element-13">
            <h3 className="font-montserrat font-bold text-2xl mb-8 text-[#EF4444] flex items-center gap-3" data-id="element-14">
              <XCircleIcon className="w-8 h-8" data-id="element-15" />
              ESTO NO ES PARA TI SI:
            </h3>
            <ul className="space-y-6" data-id="element-16">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-17">
                  <div className="mt-1 bg-[#EF4444]/20 p-1 rounded-full" data-id="element-18">
                    <XCircleIcon className="w-5 h-5 text-[#EF4444]" data-id="element-19" />
                  </div>
                  <span className="font-inter text-lg text-gray-300" data-id="element-20">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}